import * as React from 'react'
import useModalAccessibility from '../../../../Shared/hooks/useModalAccessibility';
import DemoGuardedButton from '../../shared/demoGuardedButton';

const RemoveActivityModal = ({ activityName, closeFunction, removeFunction, }) => {
  const { modalRef } = useModalAccessibility(closeFunction);

  return (
    <div aria-live="polite" className="modal-container copy-dates-modal-container" tabIndex={-1}>
      <div className="modal-background" />
      <div
        aria-labelledby="copyDatesModalTitle"
        aria-modal="true"
        className="copy-dates-modal quill-modal modal-body"
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        <div className="top-section">
          <h1 id="copyDatesModalTitle">Remove this activity?</h1>
          <p>Are you sure you want to remove {activityName} from this activity pack? </p>
        </div>
        <div className="button-section">
          <button className="quill-button medium outlined grey focus-on-light" onClick={closeFunction} type="button">Cancel</button>
          <DemoGuardedButton className="quill-button medium contained green focus-on-light" onClick={removeFunction}>Yes, remove</DemoGuardedButton>
        </div>
      </div>
    </div>
  )
}

export default RemoveActivityModal
